import firebase from "firebase/compat/app";
import { useEffect } from "react";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import _ from "underscore";
import { consola } from "consola";
import { useRecoilValue, atom, useSetRecoilState } from "recoil";
import organizationIdState from "../atoms/organizationIdAtom";
import { normalizePlanLifecycleStatus } from "../pages/home/children/training-plans-v2/services/planLifecycleStatus";

export const Protocols = atom({
  key: "Protocols",
  default: [],
});

export function findProtocol({ protocolId, protocols }) {
  const protocol = _.find(protocols, { id: protocolId });
  return protocol;
}

const useProtocolsSubscription = () => {
  const setProtocols = useSetRecoilState(Protocols);

  const organizationId = useRecoilValue(organizationIdState);

  useEffect(() => {
    if (!organizationId) {
      return;
    }

    const reportRef = firebase
      .firestore()
      .collection("organizations")
      .doc(organizationId)
      .collection("protocols");

    const unsubscribe = reportRef.onSnapshot(
      (snapshot) => {
        consola.debug(
          "++++++ SNAPSHOT -> ProtocolData: useProtocolsSubscription",
        );
        setProtocols(
          snapshot.docs.map((d) => {
            const data = d.data();
            const v2 = data.v2Meta;
            if (!v2) {
              return { ...data };
            }
            const norm = normalizePlanLifecycleStatus(v2.status || data.status);
            return {
              ...data,
              v2Meta: { ...v2, status: norm },
              status: norm,
            };
          }),
        );
      },
      (error) => {
        if (error.code === "permission-denied") {
          consola.error(
            "Permission denied: Unable to access protocol data.",
            error,
          );
        } else {
          consola.error(
            "++++++ ERROR -> ProtocolData: useProtocolsSubscription",
            error,
          );
        }
      },
    );

    return () => {
      consola.debug(
        "++++++ UNSUBSCRIBE -> ProtocolData: useProtocolsSubscription",
      );
      unsubscribe();
    };
  }, [organizationId]);

  return null;
};

export default useProtocolsSubscription;
